function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Vrstva_3"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Vrstva_2"
}, React.createElement("g", null, React.createElement("path", {
  d: "M750.315,314.918c-2.518-2.764-5.647-4.971-9.217-6.572c-3.562-1.608-7.552-2.346-11.569-2.346h0.008 l-292.973-0.251c-1.213-2.531-2.69-5.384-4.491-8.316c-2.081-3.386-4.588-6.984-7.636-10.502c-2.286-2.637-4.878-5.261-7.83-7.714 c-4.421-3.676-9.678-7.016-15.781-9.408c-6.092-2.398-13.015-3.816-20.402-3.808H275.364c-4.049-0.002-7.984,0.846-11.516,2.365 c-5.306,2.283-9.725,6.019-12.861,10.696c-1.567,2.341-2.815,4.927-3.671,7.693c-0.856,2.764-1.317,5.708-1.316,8.714V336v46v99 h33v-99v-46v-37h101.425c2.607,0.003,4.794,0.37,6.796,0.979c1.749,0.537,3.362,1.271,4.916,2.197 c2.709,1.614,5.246,3.864,7.501,6.498c1.69,1.969,3.208,4.136,4.502,6.276c1.945,3.209,3.377,6.353,4.266,8.58 c0.445,1.114,0.757,1.998,0.94,2.547c0.092,0.275,0.382,0.466,0.411,0.56l0.243,0.041v0.002l-0.229,0.001l3.261,11.939 L725,338.766v361.933c-0.004,3.331-1.207,5.963-2.819,7.693c-0.809,0.864-1.707,1.498-2.671,1.929 c-0.971,0.427-2.007,0.674-3.301,0.679H288.346c-1.294-0.004-2.414-0.257-3.483-0.721c-1.59-0.693-3.06-1.922-4.132-3.575 c-1.068-1.658-1.727-3.663-1.73-6.005V622v-56h-33v56v78.699c-0.001,5.834,1.137,11.482,3.227,16.632 c3.136,7.727,8.387,14.354,15.153,19.103c3.382,2.371,7.148,4.269,11.191,5.568c4.04,1.302,8.357,1.999,12.775,1.998h427.863 c5.892,0.005,11.61-1.248,16.729-3.534c7.696-3.427,14.009-9.106,18.336-16.028c4.337-6.924,6.729-15.14,6.727-23.738V335.133 C758.003,327.703,755.363,320.459,750.315,314.918z M409.532,326.654L409.532,326.654L409.532,326.654L409.532,326.654z"
}), React.createElement("path", {
  d: "M327.485,582.274c-6.443,6.443-6.443,16.891,0,23.334c6.444,6.444,16.891,6.444,23.335,0l70.301-70.302 c6.443-6.443,6.443-16.891,0-23.334L350.82,441.67c-6.444-6.444-16.891-6.444-23.334,0c-6.444,6.444-6.444,16.891,0,23.334 L369.48,507H144c-9.113,0-16.5,7.388-16.5,16.5S134.887,540,144,540h225.759L327.485,582.274z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1000px",
    height: "1000px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/custom-plu.ff53e811.svg";
export { SvgComponent as ReactComponent };